import { LIST_INVENTORY_LOCATIONS_REQUEST } from './constants';

export const listPickupLocations = () => ({
  type: LIST_INVENTORY_LOCATIONS_REQUEST
});
